import styled from 'styled-components'

export default styled.span`
    display: block;
    height: 1px;
    width: 1px;
    padding-top: ${(props) => (props.vertical ? 0 : props.size)}px;
    padding-right: ${(props) => (props.vertical ? props.size : 0)}px;
`
